export default __webpack_public_path__ + "static/media/instagram.c5fa0910.svg";